module.exports = __webpack_public_path__ + "img/imgnew-8.75c7c247.jpg";